// Essays shown on /essays. Each opens in a modal; add a `body` field later
// for the full piece.
const essays = [
  {
    date: "JUN 2026",
    title: "What good python code looks like",
    dek: "Readable > clever",
    tag: "CRAFT",
    body: (
      <>
        <p>
          In an AI slop code era, you'll often find a combination of useless error handling,
          useless logging, classes violating OOP principles, & code that's been dead for months.
          Good code is written for the next person — usually you, six months from now.
        </p>
        <h4>good error handling </h4>
        <p>
          One of the biggest anti-patterns you can see is a{" "}
          <code>try/except</code> around every other line, swallowing the error
          and logging a general Exception — the workflow that turns a precise
          stack trace into a mystery.
        </p>
        <pre>
          <code>{`try:
    boto3.client("s3").put_object(...)
except Exception as e:
    logger.error(e)
    raise`}</code>
        </pre>
        <p>
          Catch an exception only when you can actually do something about it —
          retry, fall back, or translate it into a domain error that means
          something to the caller. If you can’t, let it bubble up. An unhandled
          exception that crashes loudly at the responsible layer will tell
          you exactly what broke and where.
        </p>

        <h4>Log worthwile events / not thought procceses </h4>
        <p> 
          The log should help answer what happened?, not narrate every line of code
          and not to mention the cost as well burying logs that matter when it comes 
          to debugging real problems.
        </p>
        <p>
          Good logging is structured and lives at the boundaries: a request came
          in (with an id), an external call failed (with the args), a job
          finished (with a duration). Log decisions and failures, not narration.
        </p>

        <h4>good frameworks keep core logic away from the world</h4>
        <p>
          The highest-leverage structural idea is <em>ports &amp; adapters</em>{" "}
          (hexagonal architecture). Your business logic shouldn’t know whether
          data comes from Postgres, a CSV, or an HTTP call. It depends on an
          interface, a <em>port</em> — and in{" "}
          <em>adapters</em> you can swap out.
        </p>
        <p>
          The payoff is your important code becomes easy to test, no mocking 
          aws calls just to check a basic calculation. 
          Migrating to newer tools becomes seamless, and debugging is simple
        </p>
      </>
    ),
  },
  {
    date: "MAR 2026",
    title: "good sys design",
    dek: "Cold starts, fan-out, & architecture",
    tag: "SYSTEMS",
    body: (
      <>
        <p>
          Designing things well from the beginning becomes more & more valuable as systems grow.
          Seperation business logic from the tech is key. Design around contracts and not infra.
        </p>
        <p>
          A Lambda triggered by SQS today can become an ECS service polling the same queue tomorrow.
          The queue doesn't change / The business logic doesn't change / Only the compute changes.
        </p>
        <p>
          if moving compute requires completely rewriting your application, your architecture too tightly
          coupled to begin with. Services should have one job, and clear ownership.
        </p>
        <p>
          the highest leverage things you can for systems design are often easy to implement.
          ie: S3 for blob storage, utilizing API Gateway, utilizing autoscaling, making use of queue.
        </p>
      </>
    ),
  },
  {
    date: "APR 2026",
    title: "The DoorDash model → solving real problems",
    dek: "finding a problem is harder than building",
    tag: "PRODUCT",
    body: (
      <>
        <p>
          The barrier to building keeps getting lower, but finding something worth building is still hard.
          The DoorDash founders didn't start with "let's build an app with xyz", but instead went out and talked 
          to real people to find real problems worth solving.
        </p>
        <p>
          - They noticed taxi drivers sitting around waiting for rides.
          - Restaraunts who wanted to do deliveries but couldn't afford full time drivers.
          - Customers who wished they could get their meals at their door.
          DoorDash identified the gap & became the missing link.
        </p>
        <p>
          We spend weeks thinking about what to build instead of who has a problem / what we're even solving.
          Building has never been easier. Finding something worth building is still the hard part.
        </p>
      </>
    ),
  },
  {
    date: "JUN 2026",
    title: "Shipping vibe-coded apps",
    dek: "working with zero users vs real traffic",
    tag: "CRAFT",
    body: (
      <>
        <p>
          You can open replit, explain the idea in english, and watch the agent build the app for you.
          Then you look at the code, a table has five status columns because the agent kept adding a new one instead 
          of understanding the old one, API routes and components for features that no longer exist.
        </p>
        <p>
          Getting something to work once is very different from getting it ready for real traffic. Every individual decision looks harmless. 
          A few months later & the schema is telling five different stories. 1 UGC ad gets traction and the app blows up,
          suddently the DB connection pools fills up, OOM issues pop up & logs explode with useless details.
        </p>
        <p>
          AI lets you produce bad decisions much faster than before, and because the app looks finished, 
          it’s easy to forget that nobody reviewed a PR, and 0 test cases were written.
        </p>
        <p>
          Tools like replit are amazing for building an MVP out of nothing, validating ideas without 
          wasting weeks of effort building infra for users who might never come. But before shipping,
          run it through some skills, take a look at the ERD, make the API calls make sense to you.
        </p>
        <p>
          On the other hand, it's possible to get obsessed with scaling problems you might never had.
          delaying shipping because your concerned about global replication & geo-based caching, without
          having any users is not worth the time/effort.
        </p>
      </>
    ),
  },
  {
    date: "MAY 2026",
    title: "GPT wrappers & MOATs",
    dek: "what makes a product hard to copy",
    tag: "STRATEGY",
    body: (
      <>
        <p>
          You can open claude or windsurf and have a working MVP by the end of the weekend.
          Wrappers make it easy to ship anything, the problem is building something nobody actually needs is.
        </p>
        <p>
          Models get better. APIs get cheaper. Prompts get copied.
          6 months from now, someone else will have access to the same foundation models or better.
        </p>
        <p>
          What doesn't get copied as easily is understanding your users better than everyone else.
          Your data, your integrations, or the habits people have built around your product.
        </p>
      </>
    ),
  },
  {
    date: "MAY 2026",
    title: "valuable products without AI calls",
    dek: "using AI where it helps & ignoring where it doesn't",
    tag: "STRATEGY",
    body: (
      <>
        <p>
          I've seen apps call an LLM to do something that could've been solved with 25 lines of code.
          Besides latency and cost, this introduces another failure point for a feature thats 100% deterministic.
        </p>
        <p>
          Not everything needs intelligence, sometimes it just needs decent logic.
          Youtube doesn't call GPT to recommend a video, Zocodc doesn't call an LLM to find you a doctor.
        </p>
        <p>
          If you can explain the rules, then you probably don't need an LLM.
        </p>
      </>
    ),
  },
  {
    date: "JAN 2026",
    title: "TDD, big-O & everything that doesn’t matter",
    dek: "things that don't matter after interviews",
    tag: "OPINION",
  },
  {
    date: "DEC 2025",
    title: "CS concepts still worth learning",
    dek: "the principles still worth learning with AI around",
    tag: "CRAFT",
  },
  {
    date: "FEB 2026",
    title: "image store tradeoffs (without VC funding)",
    dek: "keeping it reasonable and efficient",
    tag: "SYSTEMS",
  },
];

export default essays;
